export default __webpack_public_path__ + "static/media/Tinos-Bold.662a7db4.ttf";